const CHANNEL_LIST = ['offline', 'online'];
export const CHANNELS = CHANNEL_LIST.map((type) => ({
    key: type,
    label: `resource.channel.options.${type}.label`,
}));
